import React, { ReactNode } from 'react';

interface ConditionalChatProviderProps {
  children: ReactNode;
}

/**
 * Historical wrapper for Twilio Conversations ChatProvider.
 * Live support uses SupportChatWidget + useSupportChat (WebSocket API), and nothing
 * calls useChat — so we do not mount ChatProvider on public pages. That keeps
 * `@twilio/conversations` (~100KB+) off the event-detail critical path (PSI TBT/LCP).
 */
export const ConditionalChatProvider: React.FC<ConditionalChatProviderProps> = ({ children }) => (
  <>{children}</>
);
